(function () {
  "use strict";

  function initMissionVision(section) {
    if (!section) return;

    const cards = section.querySelectorAll(".vs-mv__card");

    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener("mouseenter", function () {
        card.classList.add("vs-mv__card--active");
      });

      card.addEventListener("mouseleave", function () {
        card.classList.remove("vs-mv__card--active");
      });
    });
  }

  function initAll() {
    document.querySelectorAll(".vs-mv").forEach(function (section) {
      initMissionVision(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    const section = event.target.querySelector(".vs-mv");

    if (section) {
      initMissionVision(section);
    }
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const section = event.target.querySelector(".vs-mv");

    if (!section) return;

    section.querySelectorAll(".vs-mv__card").forEach(function (card) {
      card.replaceWith(card.cloneNode(true));
    });
  });
})();